import { createContext, useContext, useEffect, useState } from "react";
import { DEFAULT_CONTENT, deepMerge } from "./defaults";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({ content: DEFAULT_CONTENT });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    fetch(`${API}/content`, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d && d.data) setContent(deepMerge(DEFAULT_CONTENT, d.data));
      })
      .catch(() => {});
  }, []);

  return <ContentContext.Provider value={{ content }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
